var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduledMeetingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_linear_597_35247)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint1_linear_597_35247)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4062 22.625C18.4062 23.8681 17.3994 24.875 16.1562 24.875C14.9131 24.875 13.9062 23.8681 13.9062 22.625C13.9062 21.3819 14.9131 20.375 16.1562 20.375C17.3994 20.375 18.4062 21.3819 18.4062 22.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1562 23.75C16.4546 23.75 16.7408 23.6315 16.9517 23.4205C17.1627 23.2095 17.2812 22.9234 17.2812 22.625C17.2812 22.3266 17.1627 22.0405 16.9517 21.8295C16.7408 21.6185 16.4546 21.5 16.1562 21.5C15.8579 21.5 15.5717 21.6185 15.3608 21.8295C15.1498 22.0405 15.0312 22.3266 15.0312 22.625C15.0312 22.9234 15.1498 23.2095 15.3608 23.4205C15.5717 23.6315 15.8579 23.75 16.1562 23.75ZM16.1562 24.875C17.3994 24.875 18.4062 23.8681 18.4062 22.625C18.4062 21.3819 17.3994 20.375 16.1562 20.375C14.9131 20.375 13.9062 21.3819 13.9062 22.625C13.9062 23.8681 14.9131 24.875 16.1562 24.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 28.5566C11.375 26.8567 14.5604 26 16.1562 26C17.7521 26 20.9375 26.8567 20.9375 28.5566V31.625H11.375V28.5566Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6879 28.2404C12.5101 28.4159 12.5 28.5166 12.5 28.5571V30.5H19.8125V28.5566C19.8125 28.5172 19.8024 28.4159 19.6246 28.2404C19.4368 28.0554 19.1268 27.8568 18.7021 27.6751C17.8471 27.3089 16.8031 27.125 16.1562 27.125C15.5094 27.125 14.4648 27.3089 13.6104 27.6751C13.1857 27.8568 12.8757 28.0554 12.6879 28.2404ZM16.1562 26C14.5604 26 11.375 26.8567 11.375 28.5566V31.625H20.9375V28.5566C20.9375 26.8567 17.7521 26 16.1562 26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 22.625C29.0938 23.8681 28.0869 24.875 26.8438 24.875C25.6006 24.875 24.5938 23.8681 24.5938 22.625C24.5938 21.3819 25.6006 20.375 26.8438 20.375C28.0869 20.375 29.0938 21.3819 29.0938 22.625Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8438 23.75C27.1421 23.75 27.4283 23.6315 27.6392 23.4205C27.8502 23.2095 27.9688 22.9234 27.9688 22.625C27.9688 22.3266 27.8502 22.0405 27.6392 21.8295C27.4283 21.6185 27.1421 21.5 26.8438 21.5C26.5454 21.5 26.2592 21.6185 26.0483 21.8295C25.8373 22.0405 25.7188 22.3266 25.7188 22.625C25.7188 22.9234 25.8373 23.2095 26.0483 23.4205C26.2592 23.6315 26.5454 23.75 26.8438 23.75ZM26.8438 24.875C28.0869 24.875 29.0938 23.8681 29.0938 22.625C29.0938 21.3819 28.0869 20.375 26.8438 20.375C25.6006 20.375 24.5938 21.3819 24.5938 22.625C24.5938 23.8681 25.6006 24.875 26.8438 24.875Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 21.5C23.75 22.7431 22.7431 23.75 21.5 23.75C20.2569 23.75 19.25 22.7431 19.25 21.5C19.25 20.2569 20.2569 19.25 21.5 19.25C22.7431 19.25 23.75 20.2569 23.75 21.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 22.625C21.7984 22.625 22.0845 22.5065 22.2955 22.2955C22.5065 22.0845 22.625 21.7984 22.625 21.5C22.625 21.2016 22.5065 20.9155 22.2955 20.7045C22.0845 20.4935 21.7984 20.375 21.5 20.375C21.2016 20.375 20.9155 20.4935 20.7045 20.7045C20.4935 20.9155 20.375 21.2016 20.375 21.5C20.375 21.7984 20.4935 22.0845 20.7045 22.2955C20.9155 22.5065 21.2016 22.625 21.5 22.625ZM21.5 23.75C22.7431 23.75 23.75 22.7431 23.75 21.5C23.75 20.2569 22.7431 19.25 21.5 19.25C20.2569 19.25 19.25 20.2569 19.25 21.5C19.25 22.7431 20.2569 23.75 21.5 23.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9374 15.2186C20.9374 14.4976 20.651 13.8061 20.1411 13.2962C19.6313 12.7864 18.9398 12.5 18.2188 12.5H16.4363C15.6987 12.4988 14.9902 12.7875 14.4635 13.3039C13.9368 13.8203 13.6342 14.523 13.6208 15.2605C13.6075 15.9979 13.8845 16.7111 14.3921 17.2462C14.8997 17.7813 15.5973 18.0955 16.3344 18.1211L16.4374 18.125V19.25C16.4374 19.25 20.9374 18.5936 20.9374 15.2186ZM22.6249 14.3203C22.6249 13.5391 22.9352 12.79 23.4875 12.2376C24.0399 11.6853 24.789 11.375 25.5701 11.375H28.8124C29.5583 11.375 30.2737 11.6713 30.8011 12.1988C31.3286 12.7262 31.6249 13.4416 31.6249 14.1875C31.6249 14.9334 31.3286 15.6488 30.8011 16.1762C30.2737 16.7037 29.5583 17 28.8124 17H27.6874V18.6875C27.6874 18.6875 22.6249 17.9765 22.6249 14.3203ZM22.0624 28.5566C22.0624 26.8567 25.2478 26 26.8436 26C28.4394 26 31.6249 26.8567 31.6249 28.5566V31.625H22.0624V28.5566Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3753 28.2404C23.1975 28.4159 23.1874 28.5166 23.1874 28.5571V30.5H30.4999V28.5566C30.4999 28.5172 30.4898 28.4159 30.312 28.2404C30.1241 28.0554 29.8142 27.8568 29.3895 27.6751C28.5345 27.3089 27.4905 27.125 26.8436 27.125C26.1968 27.125 25.1522 27.3089 24.2978 27.6751C23.8731 27.8568 23.5631 28.0554 23.3753 28.2404ZM26.8436 26C25.2478 26 22.0624 26.8567 22.0624 28.5566V31.625H31.6249V28.5566C31.6249 26.8567 28.4394 26 26.8436 26ZM21.4999 27.4316C21.4999 26.4882 20.4609 25.8043 19.2471 25.3824C19.9515 25.0495 20.7208 24.8763 21.4999 24.875C22.279 24.8763 23.0483 25.0495 23.7527 25.3824C22.5388 25.8043 21.4999 26.4882 21.4999 27.4316Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4999 27.4316C21.4999 26.9293 21.7946 26.5001 22.2536 26.1452L22.3329 26.0861C22.725 25.8015 23.2217 25.5669 23.7527 25.383C23.2258 25.1346 22.6619 24.974 22.0832 24.9077C21.6955 24.8641 21.3042 24.8641 20.9166 24.9077C20.3379 24.9738 19.774 25.1342 19.2471 25.3824C19.7775 25.5669 20.2748 25.8015 20.6663 26.0855C20.6933 26.1052 20.7197 26.1249 20.7456 26.1452C21.2051 26.4995 21.4999 26.9293 21.4999 27.4316Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_35247",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_35247",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16D9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#30C7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46AEF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledMeetingIcon);
export default __webpack_public_path__ + "static/media/scheduledMeeting-icon.8c5b9608e39cbc03fab61cfce6c3127e.svg";
export { ForwardRef as ReactComponent };